module.exports = __webpack_public_path__ + "img/horizontal_7_1_8017.4cfdcb14.png";